import {Hero, Section} from '@primer/react-brand'

interface Props {
  id: string
}

export function Intro({id}: Props) {
  return (
    <Section id={id}>
      <Hero data-hpc align="center">
        <Hero.Heading size="2">Build and ship software on a single, collaborative platform</Hero.Heading>
        <Hero.Description size="300">
          Join the industry’s leading AI-powered developer platform where millions of developers, thousands of
          businesses, and the world’s largest open source community create the software that shapes our world.
        </Hero.Description>
        <Hero.PrimaryAction href="#TODO">Sign up</Hero.PrimaryAction>
        <Hero.SecondaryAction href="#TODO">Try GitHub Copilot</Hero.SecondaryAction>
      </Hero>
    </Section>
  )
}

try{ Intro.displayName ||= 'Intro' } catch {}